import { authUtilityURL, authWebComponentURL } from '@consumer/auth-utility-loader';

const isProd = process.env.CONFIG === 'prod';
const regionShort = process.env.REGION_SHORT || 'use1';
const atcBaseUrl = isProd ? 'https://www.autotrader.com' : 'https://test.autotrader.com';
const kbbBaseUrl = isProd ? 'https://www.kbb.com' : 'https://staging.kbb.com';
const kbbAndAtcLogoImgUrl = 'https://www.autotrader.com/psx-static/main/psx-buy-kbb/CombinedLandingLogos.webp';
const psxTransactionBaseUrl = isProd ? 'https://rp-ps-scuderia.awscmsprivateseller.autotrader.com' : 'https://rp-ps-scuderia.awscmsprivatesellernp.autotrader.com';
const popularListingsPath = '/api/listings/search/recentlistings?status=active&page_size=15&has_images=true';
const staticUrl = process.env.STATIC_URL && '/';
const sellYourCarSuv = 'https://www.autotrader.com/psx-static/main/psx-buy-kbb/SellSuv.webp';
const shopPrivateSellerCarsUrl = `${kbbBaseUrl}/cars-for-sale/used/by-owner`;
const sellMyCarUrl = `${atcBaseUrl}/sell-my-car`;
const viewMyDashboardUrl = `${atcBaseUrl}/marketplace/dashboard`;
const dateTime = new Date().getTime();

const authUtilityModuleUrl = authUtilityURL();
const authWebComponentUrl = authWebComponentURL();
const littleGuyModuleWebComponentUrl = isProd ? `https://use1-user-webcomponents-node-master.awscsuser.kbb.com/build/node.esm.js?v=${dateTime}`
  : `https://use1-user-webcomponents-node-master.awscsusernp.kbb.com/build/node.esm.js?v=${dateTime}`;
const littleGuyNoModuleWebComponentUrl = isProd ? `https://use1-user-webcomponents-node-master.awscsuser.kbb.com/build/node.esm.js?v=${dateTime}`
  : `https://use1-user-webcomponents-node-master.awscsusernp.kbb.com/build/node.esm.js?v=${dateTime}`;
const globalNavDataBaseUrl = isProd ? `https://${regionShort}-globalnav-api-master.awskbbcs.kbb.com` : `https://${regionShort}-globalnav-api-master.awskbbcsnp.kbb.com`;
const globalNavDataPath = '/api/navigation/kbb';
const optimizelySdkKey = isProd ? '7Cv1BBWA6VS6q8wsJyeE9' : 'MX5P86GRKya36dYU2Z37W';
const globalNavDataApiKey = process.env.GLOBAL_NAV_API_KEY;
const stackId = process.env.STACK_ID;

const psxStaticUtilUrl = '/psx-buy/js/psxkbb-static-util.js';

export {
  isProd,
  atcBaseUrl,
  kbbBaseUrl,
  kbbAndAtcLogoImgUrl,
  staticUrl,
  psxTransactionBaseUrl,
  popularListingsPath,
  sellYourCarSuv,
  shopPrivateSellerCarsUrl,
  sellMyCarUrl,
  viewMyDashboardUrl,
  littleGuyModuleWebComponentUrl,
  littleGuyNoModuleWebComponentUrl,
  globalNavDataBaseUrl,
  globalNavDataPath,
  optimizelySdkKey,
  globalNavDataApiKey,
  regionShort,
  psxStaticUtilUrl,
  authWebComponentUrl,
  authUtilityModuleUrl,
  stackId,
};
